<template>
  <div>
    <v-tooltip
      v-if="support_index"
      bottom
      >
      <span>{{idxDesc}}</span>
      <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            tile
            small
            v-bind="attrs"
            v-on="on"
            target="_blank"
            :to="to"
            >
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
      </template>
    </v-tooltip>
  </div>
</template>
<script>
import {debug} from "@/api/logging"
import {column_name_mapping} from "@/api/mappings"
const idx_name_mapping = Object.assign({}, column_name_mapping)
delete idx_name_mapping['journal']
delete idx_name_mapping['journal_name']
const journal_idx = ['journal', 'journal_name']
export default {
  computed: {
    to() {
      const uniname = this.uniname
      const idx = this.idx
      if(journal_idx.includes(this.idx)) {
        return {name:'JournalHome', params: {uniname}}
      }
      const ikey = this.ikey
      const imetano = this.item.metano
      debug(uniname, idx, ikey, imetano)
      const desc = idx_name_mapping[this.idx]
      return desc ? {name:'JournalIdx', params: {uniname, idx, ikey, imetano}} : {name:'JournalHome', params: {uniname}}
    },
    idxDesc() {
      if(journal_idx.includes(this.idx)) {
        return '開啟本期刊目錄'
      }
      const desc = idx_name_mapping[this.idx]
      return desc ? `開啟本期刊 - ${desc}目錄` : '開啟本期刊目錄'
    },
    uniname() {
      return this.item.metano.slice(0, 3)
    },
    mainset_id() {
      return this.$u.find_mainset(this.uniname).mainset_id
    },
    ikey() {
      if(this.idx == 'title') {
        return this.item['title'].slice(0, 1)
      }
      return this.item[this.idx]
    },
    support_index() {
      // TODO 將索引支援清單與 ArticleView 整合
      if(['dit', 'dic', 'dif'].includes(this.item.metano.slice(0, 3))) {
        // debug('idx', this.idx)
        if(['journal', 'title'].includes(this.idx)) {
          return true
        }
        return false
      }
      if(this.mainset_id == 'cbs') {
        if(['journal', 'branch'].includes(this.idx)) {
          return true
        }
        return false
      }
      if(['wai', 'diw'].includes(this.uniname)) {
        if(['journal', 'volno'].includes(this.idx)) {
          return false
        }
        if(['dynasty'].includes(this.idx)) {
          return true
        }
      }
      if(['title', 'dynasty'].includes(this.idx)) {
        return false
      }
      if(['volno', 'pubtime', 'authors', 'journal', 'journal_name'].includes(this.idx)) {
        return true
      }
      return false
    },
  },
  props: {
    idx: {
      default: 'journal',
    },
    item: {
      required: true,
    },
  },
}
</script>
